import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import { Notifications } from '@/common';
import { queryClient } from '@/library/react-query';

const ErrorFallback = () => {
  return (
    <div className="error-fallback-container" role="alert">
      <h2 className="error-fallback-text">Ooops, something went wrong :( </h2>
      <button
        className="error-fallback-refresh-button"
        onClick={() => window.location.assign(window.location.origin)}
      >
        Refresh
      </button>
    </div>
  );
};

/* Triggering build for all other products with this comment */

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <QueryClientProvider client={queryClient}>
          {process.env.NODE_ENV !== 'production' && <ReactQueryDevtools />}
          <Notifications />
          {children}
        </QueryClientProvider>
      </ErrorBoundary>
      <div id="loader-root"></div>
    </>
  );
};
